import { KeyMessageItemsSubscription } from "@/data-access/news-feeds/queries/key-message-queries";
import { updateKeyMessageFromSubscription } from "@/store/news-feed/key-messages/key-message-async.actions";
import useKeyMessageStore from "@/store/news-feed/key-messages/key-message.slice";
import type { KeyMessage } from "@/store/news-feed/key-messages/key-message.slice";
import { useAnalysisParamsForQueries } from "@/store/news-feed/params/useAnalysisParamsForQueries";
import { useSubscription } from "urql";

export const useKeyMessageSubscriptions = () => {
  const { feedId, startDate, endDate, selectedFilters } =
    useAnalysisParamsForQueries();

  // Pause subscription while fetching key messages to avoid race conditions
  const isFetchingKeyMessagesAndGroups = useKeyMessageStore(
    (state) => state.isFetchingKeyMessagesAndGroups,
  );

  const filters =
    feedId && startDate && endDate
      ? {
          feedId,
          dateRange: {
            startDate,
            endDate,
          },
          state: "ADDED" as const,
          ...(selectedFilters ?? { AND: [] }),
        }
      : null;

  // Pause subscription if no filters OR if currently fetching key messages
  const shouldPause = !filters || isFetchingKeyMessagesAndGroups;

  const [res] = useSubscription<{ keyMessageItemV2: KeyMessage }>(
    {
      query: KeyMessageItemsSubscription,
      variables: { filters },
      pause: shouldPause,
    },
    (_prev, result) => {
      // Process each update in the reducer - this runs for EVERY WebSocket message,
      // avoiding React batching issues that occur with useEffect
      if (result.keyMessageItemV2) {
        updateKeyMessageFromSubscription(result.keyMessageItemV2);
      }
      return result;
    },
  );

  return res;
};
